"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class DetectedDevice extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'detectedDevice';
        this._gatewayId = initParams.gateway_id;
        this._deviceType = initParams.device_type;
        this._assetCode = initParams.asset_code;
        this._sku = initParams.sku;
        this._displayName = initParams.display_name;
        this._displayImage = initParams.display_image;
        this._detectingState = initParams.detecting_state;
    }
    set gatewayId(value) {
        console.error('Do not set objects this way');
    }
    setGatewayId(value) {
        return this.dataService.updateDetectedDevice(this.id, { gateway_id: value }, this);
    }
    get gatewayId() {
        return this._gatewayId;
    }
    set deviceType(value) {
        console.error('Do not set objects this way');
    }
    setDeviceType(value) {
        return this.dataService.updateDetectedDevice(this.id, { device_type: value }, this);
    }
    get deviceType() {
        return this._deviceType;
    }
    set assetCode(value) {
        console.error('Do not set objects this way');
    }
    setAssetCode(value) {
        return this.dataService.updateDetectedDevice(this.id, { asset_code: value }, this);
    }
    get assetCode() {
        return this._assetCode;
    }
    set sku(value) {
        console.error('Do not set objects this way');
    }
    setSku(value) {
        return this.dataService.updateDetectedDevice(this.id, { sku: value }, this);
    }
    get sku() {
        return this._sku;
    }
    set displayName(value) {
        console.error('Do not set objects this way');
    }
    setDisplayName(value) {
        return this.dataService.updateDetectedDevice(this.id, { display_name: value }, this);
    }
    get displayName() {
        return this._displayName;
    }
    set displayImage(value) {
        console.error('Do not set objects this way');
    }
    setDisplayImage(value) {
        return this.dataService.updateDetectedDevice(this.id, { display_image: value }, this);
    }
    get displayImage() {
        return this._displayImage;
    }
    set detectingState(value) {
        console.error('Do not set objects this way');
    }
    setDetectingState(value) {
        return this.dataService.updateDetectedDevice(this.id, { detecting_state: value }, this);
    }
    get detectingState() {
        return this._detectingState;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateDetectedDevice(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
}
exports.default = DetectedDevice;
//# sourceMappingURL=detectedDevice.js.map